import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import FrequentlyAskedQuestions from '@/components/organism/FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import HowAssistantWorks from '@/components/organism/HowAssistantWorks/HowAssistantWorks';
import Welcome from '@/components/organism/Welcome/Welcome';
import WhatIsFleetAssistant from '@/components/organism/WhatIsFleetAssistant/WhatIsFleetAssistant';
import {Article, Container, StyledHeading} from "@/components/pages/GetStarted/GetStartedPage.styles";
import { selectCurrentPage, selectCurrentPageProps } from '@/store/about/aboutSlice';
import { ComponentToElement } from '@/store/about/pageToContent';

export const aboutMap: ComponentToElement = {
  welcomePage: <Welcome />,
  fleetAssistantOverview: <WhatIsFleetAssistant />,
  assistantFunctionality: <HowAssistantWorks />,
  frequentlyAskedQuestions: <FrequentlyAskedQuestions />,
};

const GetStartedPage = () => {
  const activePage = useSelector(selectCurrentPage);
  const activePageProps = useSelector(selectCurrentPageProps);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activePage]);

  return (
    <Container>
      <Article>
        {activePage !== 'page1' ? (
          <StyledHeading className="h2 margin-bottom-15 margin-top-0">
            <FormattedMessage id={activePageProps.translation} />
          </StyledHeading>
        ) : null}
        {aboutMap[activePageProps.componentId]}
      </Article>
    </Container>
  );
};

export default GetStartedPage;
